export default {
  ite: '/',
  library: '/library',
  template: '/library/:templateId',
  notFound: '/404',
  docs: 'http://template.itentialapis.io/v1/docs/',
  developerHub: 'https://developer.itential.io/',
};
